import { forwardRef } from "react"
import { mergeRefs } from "../../utils/mergeRefs"
import { TableSelectionMessageProps } from "./types"
import { useTableContext } from "../TableContext"

/**
 * Renders a message at the top of the table, below the column headers.
 * In order to maintain the relationship of the HTML datatable, this component is absolutely positioned over the TableHead
 */
export const TableSelectionMessage = forwardRef<HTMLDivElement, TableSelectionMessageProps>(
  ({ children, ...rest }, ref) => {
    const { afterColumnHeadersTop, afterColumnHeadersRef } = useTableContext()

    return (
      <div
        {...rest}
        style={{ top: afterColumnHeadersTop - 2 }} // - 2 accounts for box shadows
        ref={mergeRefs(afterColumnHeadersRef, ref)}
        className="gray absolute left-0 right-0 z-50 flex gap-2 bg-gradient-neutral px-4 py-2 text-sm text-gray-400 shadow-[inset_0px_-1px_0px,inset_0px_2px_0px] shadow-gray-200"
      >
        {children}
      </div>
    )
  },
)
TableSelectionMessage.displayName = "Table.SelectionMessage"
